export var ChatState;
(function (ChatState) {
    ChatState["Active"] = "Active";
    ChatState["Archived"] = "Archived";
})(ChatState || (ChatState = {}));
//# sourceMappingURL=chat-state.const.js.map